import { Link, NavLink, useLocation } from 'react-router-dom';
import { Navbar, NavbarBrand, Nav, NavItem, Collapse } from 'reactstrap';
import './Header.scss';
import SvgIcon from 'components/SvgIcon';
import { useAppSelector } from 'app/hooks';
import { ROUTES } from 'app/routes';
import { useState, useEffect } from 'react';
import { getExternalLink } from 'utils/links';
import AboutUs from 'components/AboutUs';

const AppHeader = () => {
  const { organization } = useAppSelector(state => state.organizationData);
  const [navbarIsOpen, setNavbarIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavbarIsOpen(false);
  }, [location.pathname]);

  const toggleNavbar = () => setNavbarIsOpen(value => !value);

  return (
    <Navbar className="navbar-header" expand="md" fixed="top">
      <button className="navbar-toggler" onClick={toggleNavbar}>
        <SvgIcon name="sidebar/toggle-sidebar" />
      </button>
      {organization?.webAddress
        ? <NavbarBrand href={getExternalLink(organization.webAddress)} rel="noreferrer" target="_blank">
          {organization?.logo ? <img alt="Logo" src={organization.logo} /> : <SvgIcon name="Logo" title="WorkerSpring" />}
        </NavbarBrand>
        : <NavbarBrand tag={Link} to="/">
          {organization?.logo ? <img alt="Logo" src={organization.logo} /> : <SvgIcon name="Logo" title="WorkerSpring" />}
        </NavbarBrand>
      }
      <Collapse isOpen={navbarIsOpen} navbar>
        <Nav className="me-auto" navbar>
          {organization?.isHomeEnabled !== false && (
            <NavItem>
              <NavLink className="nav-link btn btn-link" to={ROUTES.HUB_POSTS} onClick={() => setNavbarIsOpen(false)}>Home</NavLink>
            </NavItem>
          )}
          {organization?.isProductsServicesEnabled !== false && (
            <NavItem>
              <NavLink className="nav-link btn btn-link" to={ROUTES.PRODUCTS_SERVICES} onClick={() => setNavbarIsOpen(false)}>Products & Services</NavLink>
            </NavItem>
          )}
          {organization?.isEventsEnabled !== false && (
            <NavItem>
              <NavLink className="nav-link btn btn-link" to={ROUTES.EVENTS} onClick={() => setNavbarIsOpen(false)}>Events</NavLink>
            </NavItem>
          )}
          {organization?.isJobsEnabled !== false && (
            <NavItem>
              <NavLink className="nav-link btn btn-link" to={ROUTES.OPPORTUNITIES} onClick={() => setNavbarIsOpen(false)}>Jobs</NavLink>
            </NavItem>
          )}
          <NavItem>
            <NavLink className="nav-link btn btn-link" to={ROUTES.PROGRAMS} onClick={() => setNavbarIsOpen(false)}>Groups</NavLink>
          </NavItem>
          <NavItem>
            <AboutUs onClose={() => setNavbarIsOpen(false)} />
          </NavItem>
        </Nav>
        <Nav navbar>
          <NavItem>
            <Link className="nav-link btn btn-primary" to={ROUTES.PROGRAMS} onClick={() => setNavbarIsOpen(false)}>Join the Community</Link>
          </NavItem>
          {/*
            * Removed based on the task:
            * WKSG-1110: Community Admin | Public Job Board: Configure Hire Members Button
            *
            {organization?.isAnyAllowHiringProgram &&
              <a className="nav-link btn btn-secondary" href={process.env.REACT_APP_HIRE_URL + '/?redirect-non-logged-in-users=1'} rel="noreferrer" target="_blank">Hire members</a>
            */}
          <NavItem>
            <a className="nav-link btn btn-link" href={process.env.REACT_APP_SIGN_IN_URL} rel="noreferrer" target="_blank" onClick={() => setNavbarIsOpen(false)}>Sign in</a>
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default AppHeader;
